import { KEYBOARD_KEYS } from "@netapp/bxp-design-system-react";
import _ from "lodash";
import { useCallback } from "react";
import { NAVIGATION_ACTIONS } from "../../constants/navigationConstants";

export const useKeyboardNavigation = (config) => {
    const {
        index,
        onKeyDown = _.noop,
        open = _.noop,
        isOpen,
        onActivate = _.noop,
        enabledActions = [NAVIGATION_ACTIONS.VERTICAL, NAVIGATION_ACTIONS.OPEN_CLOSE]
    } = config;

    return useCallback((e) => {
        const { key } = e;
        
        // Vertical navigation (arrow up/down)
        if (_.includes(enabledActions, NAVIGATION_ACTIONS.VERTICAL) && 
            (key === KEYBOARD_KEYS.ARROW_DOWN || key === KEYBOARD_KEYS.ARROW_UP)) {
            e.preventDefault();
            onKeyDown(e, index);
            return;
        }

        // Open/Close actions (arrow right/left, enter)
        if (_.includes(enabledActions, NAVIGATION_ACTIONS.OPEN_CLOSE)) {
            if ((key === KEYBOARD_KEYS.ARROW_RIGHT || key === KEYBOARD_KEYS.ENTER) && !isOpen) {
                e.preventDefault();
                open();
                return;
            }
            if (key === KEYBOARD_KEYS.ARROW_LEFT && isOpen) {
                e.preventDefault();
                open();
                return;
            }
        }

        // Activation (enter, space)
        if (_.includes(enabledActions, NAVIGATION_ACTIONS.ACTIVATE) && 
            (key === KEYBOARD_KEYS.ENTER || key === KEYBOARD_KEYS.SPACE_BAR || key === KEYBOARD_KEYS.SPACE_BAR_ALTERNATIVE)) {
            e.preventDefault();
            onActivate();
            return;
        }

        // Escape handling
        if (_.includes(enabledActions, NAVIGATION_ACTIONS.ESCAPE) && key === KEYBOARD_KEYS.ESCAPE) {
            e.preventDefault();
            onKeyDown(e, index);
            return;
        }
    }, [index, onKeyDown, open, isOpen, onActivate, enabledActions]);
};
